import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ROLES } from './config/roles';
import ProtectedRoute, { RedirectIfAuthenticated } from './components/ProtectedRoute';
import MainLogin from './components/Mainlogin.jsx';
import Dashboard from './pages/Dashboard/Dashboard.jsx';
import SideBar from './components/Sidebar/SideBar.jsx';
import EmpAnnouncments from "./pages/Announcments/Emp-Announcments";
import Teamchart from "./pages/TeamChart/TeamChart";
import EditTiming from './pages/EmpSchedule/edit-timing.js';
import UserRoles from "./pages/Roles/User-Roles";
import EditUserRole from "./pages/Roles/edit-user-role";
import AddAnnouncements from "./pages/Announcments/Add-Announcements";
import DeptAnnouncements from "./pages/DeptAnnouncements/DeptAnnouncements";
import Handbook from "./pages/HandBook/HandBook";
import DepartmentsTable from "./pages/Departments/Departments";
import AddDepartments from "./pages/Departments/Add-Departments";
import EditDepartments from "./pages/Departments/Edit-Departments";
import PublicHolidays from "./pages/Holidays/PublicHolidays";
import EditHoliday from "./pages/Holidays/Edit-PublicHoliday";
import Rules from "./pages/Rules/Rules.jsx";
import EmployeeInformation from "./pages/AddEmp/emp-info.js";
import AddEmp from "./pages/AddEmp/add-emp.js";
import HrInformation from "./pages/AddHR/hr-info.js";
import AddHR from "./pages/AddHR/add-hr.js";
import AvailableLeaves from "./pages/Leaves/AvailableLeave/available-leave.js";
import CurrentAtd from "./pages/EmpAtd/current-atd.js";
import EditAtd from "./pages/EmpAtd/edit-atd.js";
import AddAbsent from "./pages/EmpAtd/add-absent.js";
import YesterdayAttendance from "./pages/EmpAtd/yesterday-atd.js";
import ViewAtd from "./pages/EmpAtd/view-atd.js";
import AllEmps from "./pages/EmpAtd/all-emps.js";
import MonthlyAtd from "./pages/EmpAtd/current-month-atd.js";
import Reports from "./pages/reports.js";
import BradFactor from "./pages/BradfordFactor/bradfactor.js";
import ViewBradFord from "./pages/BradfordFactor/view-bradford.js";
import AllEmployee from "./pages/all-employee.js";
import EditSalary from "./pages/EmpBenefit/edit-salary.js";
import BasicSalary from "./pages/EmpBenefit/basic-salary.js";
import ProvidentFund from "./pages/EmpBenefit/provident-fund.js";
import PFHistory from "./pages/EmpBenefit/provident-fund-history.js";
import TotalLeave from "./pages/Leaves/total-leave.js";
import AddLeave from "./pages/add-leave.js";
import PendingLeave from "./pages/Leaves/pending-leave.js";
import EditLeave from "./pages/Leaves/edit-leave.js";
import ApprovedLeave from "./pages/Leaves/approved-leave.js";
import RejectedLeave from "./pages/Leaves/rejected-leave.js";
import LeaveReport from "./pages/Leaves/LeaveReport/leave-report.js";
import EmpsLeaveReports from "./pages/Leaves/LeaveReport/emps-leave-reports.js";
import Accounts from "./pages/Account/accounts.js";
import AddAccount from "./pages/Account/add-account.js";
import EditAccount from "./pages/Account/edit-account.js";
import Performance from "./pages/EmpPerformance/performance.js";
import TodayReport from "./pages/EmpWorkReport/today-report.js";
import MonthReport from "./pages/EmpWorkReport/current-month-work-report.js";
import EditWorkReport from "./pages/EmpWorkReport/edit-work-report.js";
import EmpsWorkReports from "./pages/EmpWorkReport/all-work-reports.js";
import HrSchedule from "./pages/HrSchedule/hr-schedule.js";
import HrTiming from "./pages/HrSchedule/hr-timing.js";
import HrShift from "./pages/HrSchedule/hr-shift.js";
import PFUser from "./pages/EmpBenefit/pf-user.js";
import EmpsSchedule from "./pages/EmpSchedule/emps-schedule.js";
import EmpTiming from "./pages/EmpSchedule/emps-timing.js";
import EmpShift from "./pages/EmpSchedule/emp-shift.js";
import AddHoliday from "./pages/Holidays/add-holiday.jsx";
import Leave from "./pages/Leaves/Leave.js";
import EmpPayroll from "./pages/Payroll/PayrollInfo/emp-payroll.js";
import Payrolls from "./pages/Payroll/PayrollInfo/payroll.js";
import Paid from "./pages/Payroll/PayrollInfo/paid.js";
import EmpsReports from "./pages/EmpWorkReport/emp-reports.js";
import ProcessPayroll from "./pages/Payroll/process-payroll.js";
import PayrollReports from "./pages/Payroll/payroll-report.js";
import EditEmployee from "./pages/AddEmp/edit-emp.js";
import Signin from './components/Signin.jsx';
import EditAnnouncements from './pages/Announcments/Edit-Announcements.jsx';
import EditHrTiming from './pages/HrSchedule/edit-hr-timing.js';
import AddDeptAnnouncements from './pages/DeptAnnouncements/Add-DeptAnnouncements.jsx';
import EditHR from './pages/AddHR/edit-hr.js';
import AddAtd from './pages/EmpAtd/add-atd.js';
import DeptSalary from './pages/dept-salary.js';
import { ViewAtdDay } from './pages/EmpAtd/view-atd-day.js';
import ExEmployeeInformation from './pages/AddEmp/ex-emp-info.js';
import LeaveRecords from './pages/Leaves/leave-records.js';
import AddManualLeave from './pages/Leaves/LeaveReport/add-manual-leaves.js';
import EditManualLeave from './pages/Leaves/edit-manual-leaves.js';
import EditPayroll from './pages/Payroll/edit-payroll.js';
import { ViewAbsDay } from './pages/EmpAtd/view-absent.js';
import LeaveManagement from './pages/Leaves/LeaveManagement.js';
import PayInvoice from "./pages/Payroll/PayrollInfo/pay-invoice.js";
import InterviewerData from './pages/InterviewerData/interviewer-data.js';
import InterviewerForm from './pages/InterviewerData/interviewerForm.js';
import ProtectedInterview from './components/ProtectedInterview';
import SessionGuard from './components/SessionGuard';
import AbsentManagement from './pages/Leaves/AbsentManagement.jsx';

// Sidebar wrapper
const WithSidebar = ({ children }) => (
  <>
    <SideBar />
    <div style={{ marginLeft: '250px' }}>{children}</div>
  </>
);

// Helper
const AppRoute = ({ element, roles }) => (
  <ProtectedRoute allowedRoles={roles} element={
    <WithSidebar>
      <SessionGuard>{element}</SessionGuard>
    </WithSidebar>
  } />
);

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(245, 245, 245, 0.9)',
    zIndex: 9999,
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    backdropFilter: 'blur(12px) saturate(180%)',
    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
    flexDirection: 'column',
    animation: 'fadeIn 0.4s cubic-bezier(0.39, 0.575, 0.565, 1)'
  },
  loaderBox: {
    textAlign: 'center', padding: '2.5rem 3rem', borderRadius: '18px',
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    boxShadow: '0 10px 35px rgba(0, 0, 0, 0.08)',
    backdropFilter: 'blur(6px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    transform: 'translateY(-20px)',
    animation: 'floatUp 0.5s 0.2s cubic-bezier(0.23, 1, 0.32, 1) forwards'
  },
  spinner: {
    width: '70px', height: '70px',
    border: '6px solid rgba(76, 175, 80, 0.15)',
    borderTop: '6px solid #4caf50', borderRadius: '50%',
    animation: 'spin 1.2s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite',
    margin: '0 auto', boxShadow: '0 0 20px rgba(76, 175, 80, 0.2)'
  },
  text: {
    marginTop: '1.8rem', fontSize: '1.1rem', fontWeight: '500',
    color: '#333', fontFamily: "'Segoe UI', 'Helvetica Neue', sans-serif",
    letterSpacing: '0.3px', opacity: 0,
    animation: 'fadeIn 0.6s 0.4s ease-out forwards'
  },
  refreshIcon: { display: 'inline-block', marginRight: '8px', animation: 'pulse 1.5s infinite' }
};

function App() {
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsReloading(true);
      setTimeout(() => window.location.reload(), 2000);
    }, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isReloading && (
        <div style={styles.overlay}>
          <div style={styles.loaderBox}>
            <div style={styles.spinner}></div>
            <p style={styles.text}>
              <span style={styles.refreshIcon}>🔄</span>
              Please wait... refreshing the page ✨
            </p>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes floatUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.2); } 100% { transform: scale(1); } }
      `}</style>

      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<RedirectIfAuthenticated element={<MainLogin />} />} />
          <Route path="/signin" element={<RedirectIfAuthenticated element={<Signin />} />} />

          {/* ==================== SHARED ROUTES (ADMIN + STAFF) ==================== */}
          {/* Attendance - Both Admin & Staff */}
          <Route path="/current-atd" element={<AppRoute element={<CurrentAtd />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/yesterday-atd" element={<AppRoute element={<YesterdayAttendance />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/view-atd" element={<AppRoute element={<ViewAtd />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/all-emps" element={<AppRoute element={<AllEmps />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/current-month-atd/:userId" element={<AppRoute element={<MonthlyAtd />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/view-atd-day" element={<AppRoute element={<ViewAtdDay />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/view-absents" element={<AppRoute element={<ViewAbsDay />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/edit-atd/:attendanceId" element={<AppRoute element={<EditAtd />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />

          {/* Employee Schedule - Both Admin & Staff */}
          <Route path="/emps-schedule" element={<AppRoute element={<EmpsSchedule />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/emps-timing/:userId" element={<AppRoute element={<EmpTiming />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/emp-shift" element={<AppRoute element={<EmpShift />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/edit-timing/:userId" element={<AppRoute element={<EditTiming />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />

          {/* Holidays (Leave Management) - Both Admin & Staff */}
          <Route path="/leave-management" element={<AppRoute element={<LeaveManagement />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />

          {/* ==================== ADMIN ONLY ROUTES ==================== */}
          <Route path="/dashboard" element={<AppRoute element={<Dashboard />} roles={[ROLES.ADMIN]} />} />
          <Route path="/team-chart" element={<AppRoute element={<Teamchart />} roles={[ROLES.ADMIN]} />} />
          <Route path="/handbook" element={<AppRoute element={<Handbook />} roles={[ROLES.ADMIN]} />} />
          <Route path="/rules" element={<AppRoute element={<Rules />} roles={[ROLES.ADMIN]} />} />
          <Route path="/public-holidays" element={<AppRoute element={<PublicHolidays />} roles={[ROLES.ADMIN]} />} />
          <Route path="/emp-announcements" element={<AppRoute element={<EmpAnnouncments />} roles={[ROLES.ADMIN]} />} />
          <Route path="/dept-announcements" element={<AppRoute element={<DeptAnnouncements />} roles={[ROLES.ADMIN]} />} />
          <Route path="/departments" element={<AppRoute element={<DepartmentsTable />} roles={[ROLES.ADMIN]} />} />
          <Route path="/ex-emp-info" element={<AppRoute element={<ExEmployeeInformation />} roles={[ROLES.ADMIN]} />} />
          <Route path="/today-report" element={<AppRoute element={<TodayReport />} roles={[ROLES.ADMIN]} />} />
          <Route path="/current-month-work-report" element={<AppRoute element={<MonthReport />} roles={[ROLES.ADMIN]} />} />
          <Route path="/all-work-reports" element={<AppRoute element={<EmpsWorkReports />} roles={[ROLES.ADMIN]} />} />
          <Route path="/emp-reports" element={<AppRoute element={<EmpsReports />} roles={[ROLES.ADMIN]} />} />
          <Route path="/leave" element={<AppRoute element={<Leave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/available-leave" element={<AppRoute element={<AvailableLeaves />} roles={[ROLES.ADMIN]} />} />
          <Route path="/total-leave" element={<AppRoute element={<TotalLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/pending-leave" element={<AppRoute element={<PendingLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/approved-leave" element={<AppRoute element={<ApprovedLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/rejected-leave" element={<AppRoute element={<RejectedLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/leave-report" element={<AppRoute element={<LeaveReport />} roles={[ROLES.ADMIN]} />} />
          <Route path="/emps-leave-reports" element={<AppRoute element={<EmpsLeaveReports />} roles={[ROLES.ADMIN]} />} />
          <Route path="/leave-records" element={<AppRoute element={<LeaveRecords />} roles={[ROLES.ADMIN]} />} />
          <Route path="/absent-management" element={<AppRoute element={<AbsentManagement />} roles={[ROLES.ADMIN]} />} />
          <Route path="/basic-salary" element={<AppRoute element={<BasicSalary />} roles={[ROLES.ADMIN]} />} />
          <Route path="/provident-fund" element={<AppRoute element={<ProvidentFund />} roles={[ROLES.ADMIN]} />} />
          <Route path="/provident-fund-history" element={<AppRoute element={<PFHistory />} roles={[ROLES.ADMIN]} />} />
          <Route path="/pf-user" element={<AppRoute element={<PFUser />} roles={[ROLES.ADMIN]} />} />
          <Route path="/emp-payroll" element={<AppRoute element={<EmpPayroll />} roles={[ROLES.ADMIN]} />} />
          <Route path="/payroll" element={<AppRoute element={<Payrolls />} roles={[ROLES.ADMIN]} />} />
          <Route path="/paid" element={<AppRoute element={<Paid />} roles={[ROLES.ADMIN]} />} />
          <Route path="/pay-invoice/:id" element={<AppRoute element={<PayInvoice />} roles={[ROLES.ADMIN]} />} />
          <Route path="/bradfactor" element={<AppRoute element={<BradFactor />} roles={[ROLES.ADMIN]} />} />
          <Route path="/view-bradford" element={<AppRoute element={<ViewBradFord />} roles={[ROLES.ADMIN]} />} />
          <Route path="/performance" element={<AppRoute element={<Performance />} roles={[ROLES.ADMIN]} />} />
          <Route path="/dept-salary" element={<AppRoute element={<DeptSalary />} roles={[ROLES.ADMIN]} />} />
          <Route path="/user-roles" element={<AppRoute element={<UserRoles />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-user-role/:userId" element={<AppRoute element={<EditUserRole />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-announcements" element={<AppRoute element={<AddAnnouncements />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-announcement/:id" element={<AppRoute element={<EditAnnouncements />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-dept-announcements" element={<AppRoute element={<AddDeptAnnouncements />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-departments" element={<AppRoute element={<AddDepartments />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-departments/:id" element={<AppRoute element={<EditDepartments />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-holiday" element={<AppRoute element={<AddHoliday />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-public-holidays/:id" element={<AppRoute element={<EditHoliday />} roles={[ROLES.ADMIN]} />} />
          <Route path="/hr-info" element={<AppRoute element={<HrInformation />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-hr" element={<AppRoute element={<AddHR />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-hr/:userId" element={<AppRoute element={<EditHR />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-absent" element={<AppRoute element={<AddAbsent />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-atd" element={<AppRoute element={<AddAtd />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/reports" element={<AppRoute element={<Reports />} roles={[ROLES.ADMIN]} />} />
          <Route path="/all-employee" element={<AppRoute element={<AllEmployee />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-salary/:id" element={<AppRoute element={<EditSalary />} roles={[ROLES.ADMIN]} />} />
          <Route path="/process-payroll" element={<AppRoute element={<ProcessPayroll />} roles={[ROLES.ADMIN]} />} />
          <Route path="/payroll-report" element={<AppRoute element={<PayrollReports />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-payroll/:id" element={<AppRoute element={<EditPayroll />} roles={[ROLES.ADMIN]} />} />
          <Route path="/accounts" element={<AppRoute element={<Accounts />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-account" element={<AppRoute element={<AddAccount />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-account" element={<AppRoute element={<EditAccount />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-leave" element={<AppRoute element={<AddLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-leave" element={<AppRoute element={<EditLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/add-manual-leaves" element={<AppRoute element={<AddManualLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-manual-leaves/:userId" element={<AppRoute element={<EditManualLeave />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-work-report" element={<AppRoute element={<EditWorkReport />} roles={[ROLES.ADMIN]} />} />
          <Route path="/hr-schedule" element={<AppRoute element={<HrSchedule />} roles={[ROLES.ADMIN]} />} />
          <Route path="/hr-timing/:userId" element={<AppRoute element={<HrTiming />} roles={[ROLES.ADMIN]} />} />
          <Route path="/edit-hr-timing/:userId" element={<AppRoute element={<EditHrTiming />} roles={[ROLES.ADMIN]} />} />
          {/* Employee Information - Both Admin & Staff (salary hidden for staff) */}
          <Route path="/emp-info" element={<AppRoute element={<EmployeeInformation />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/add-emp" element={<AppRoute element={<AddEmp />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/edit-emp/:userId" element={<AppRoute element={<EditEmployee />} roles={[ROLES.ADMIN, ROLES.STAFF]} />} />
          <Route path="/hr-shift" element={<AppRoute element={<HrShift />} roles={[ROLES.ADMIN]} />} />
          <Route path="/interviewers-data" element={
            <ProtectedRoute allowedRoles={[ROLES.ADMIN]} element={
              <WithSidebar>
                <ProtectedInterview>
                  <SessionGuard><InterviewerData /></SessionGuard>
                </ProtectedInterview>
              </WithSidebar>
            } />
          } />
          <Route path="/add-inteviewees-data" element={<AppRoute element={<InterviewerForm />} roles={[ROLES.ADMIN]} />} />

          <Route path="*" element={<>Not found</>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;